var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var Collapse = function Collapse(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 13 1' }, props),
    React.createElement(
      'g',
      null,
      React.createElement(
        'title',
        null,
        'Combined Shape'
      ),
      React.createElement('path', { d: 'M7 0h5.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H7z', fill: 'currentColor', fillRule: 'nonzero' })
    )
  );
};
/*eslint-enable */

export default Collapse;
//# sourceMappingURL=Collapse.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/Collapse.js